export interface ColorScheme {
  name: string;
  color: string;
  backgroundColor: string;
}

export const COLOR_SCHEME: ColorScheme[] = [
  { name: '24', color: '#484848', backgroundColor: '#cdcdcd' },
  { name: '1', color: '#484848', backgroundColor: '#fffbc2' },
  { name: '2', color: '#484848', backgroundColor: '#ffedc3' },
  { name: '3', color: '#484848', backgroundColor: '#ffe1d2' },
  { name: '4', color: '#484848', backgroundColor: '#ffe4ea' },
  { name: '5', color: '#484848', backgroundColor: '#ffdeff' },
  { name: '6', color: '#484848', backgroundColor: '#e1e0ff' },
  { name: '6', color: '#484848', backgroundColor: '#e3feeb' },
  { name: '8', color: '#484848', backgroundColor: '#e4f7cf' },
  { name: '9', color: '#484848', backgroundColor: '#dffbff' },
  { name: '10', color: '#484848', backgroundColor: '#deedff' },
  { name: '11', color: '#484848', backgroundColor: '#c3d8fa' },
  { name: '12', color: '#484848', backgroundColor: '#ededed' },
  { name: '13', color: '#ffffff', backgroundColor: '#fdda5b' },
  { name: '14', color: '#ffffff', backgroundColor: '#f0b688' },
  { name: '15', color: '#ffffff', backgroundColor: '#f87e8e' },
  { name: '16', color: '#ffffff', backgroundColor: '#e499da' },
  { name: '17', color: '#ffffff', backgroundColor: '#aa7bea' },
  { name: '18', color: '#ffffff', backgroundColor: '#afa2f4' },
  { name: '19', color: '#ffffff', backgroundColor: '#67d187' },
  { name: '20', color: '#ffffff', backgroundColor: '#bae396' },
  { name: '21', color: '#ffffff', backgroundColor: '#99daef' },
  { name: '22', color: '#ffffff', backgroundColor: '#5bd4d5' },
  { name: '23', color: '#ffffff', backgroundColor: '#55b3fe' },
]
